// Cached GET /rules/summary (legal status date for footers, deadlines for the landing timeline).
import { useEffect, useState } from "react";
import { api } from "../api";
import type { RulesSummary } from "../types";
import { onTermChange } from "../i18n/termLayer";

let cache: Promise<RulesSummary> | null = null;
// the server answers in the company's term: a new term needs a new copy
onTermChange(() => {
  cache = null;
});

export function loadRules(): Promise<RulesSummary> {
  if (!cache) {
    cache = api.rulesSummary().catch((e) => {
      cache = null;
      throw e;
    });
  }
  return cache;
}

export function useRules(): RulesSummary | null {
  const [rules, setRules] = useState<RulesSummary | null>(null);
  useEffect(() => {
    let alive = true;
    loadRules()
      .then((r) => alive && setRules(r))
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  return rules;
}
